"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var utils_1 = require("../../utils");
var utils_2 = require("@vidazoo/ui/lib/components/utils");
var button_1 = require("@vidazoo/ui/lib/components/button");
var drawer_1 = require("@vidazoo/ui/lib/components/drawer");
var nativeScrollable_1 = require("@vidazoo/ui/lib/components/nativeScrollable");
var loader_1 = require("@vidazoo/ui/lib/components/loader");
var panelHeader_1 = require("@vidazoo/ui/lib/components/panelHeader");
var pageMessage_1 = require("@vidazoo/ui/lib/components/pageMessage");
var containers_1 = require("../../containers");
var api_1 = require("../../api");
var ui_1 = require("@vidazoo/ui");
var _ = require("lodash");
var lib_1 = require("../../lib");
var react_json_view_1 = require("react-json-view");
var CacheComparison = /** @class */ (function (_super) {
    tslib_1.__extends(CacheComparison, _super);
    function CacheComparison(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onToggle = function () {
            var isOpen = _this.state.isOpen;
            _this.setState(tslib_1.__assign({}, _this.state, { isOpen: !isOpen }));
        };
        _this.onTabAnimationEnd = function () {
            utils_1.refreshAllCodeMirrorEditors();
        };
        _this.onCopy = function () {
            var cacheItem = _this.state.data.cacheItem;
            lib_1.MemoryClipboard.copy(JSON.stringify(cacheItem, undefined, 2));
        };
        _this.isWaiting = function () {
            var data = _this.state.data;
            var lastUpdated = data.lastUpdated, providerName = data.providerName;
            if (!providerName || !providerName.toLowerCase().includes("s3")) {
                return false;
            }
            var now = new Date();
            var diff = now.getTime() - lastUpdated;
            var minutes = Math.floor(diff / 1000 / 60);
            console.log(minutes);
            return minutes < 20;
        };
        _this.compare = function () {
            if (_this.props.resourceName === "widgets_new") {
                api_1.cacheComparisonWidgetsAPI.getFromCacheAndCompare(_this.props.resourceName, _this.props.itemId)
                    .then(function (res) { return _this.setItemFromCache(res.data); })
                    .catch(_this.onLoadFailed);
            }
            else {
                api_1.cacheComparisonAPI.getFromCacheAndCompare(_this.props.resourceName, _this.props.itemId, _this.props.baseUrl)
                    .then(function (res) { return _this.setItemFromCache(res.data); })
                    .catch(_this.onLoadFailed);
            }
        };
        _this.setItemFromCache = function (data) {
            _this.setState(tslib_1.__assign({}, _this.state, { data: data, isLoading: false }));
        };
        _this.onLoadFailed = function () {
            _this.setState(tslib_1.__assign({}, _this.state, { error: true, isLoading: false }));
        };
        _this.state = { isOpen: false, isLoading: true, error: false, data: {} };
        _this.compare();
        return _this;
    }
    CacheComparison.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(loader_1.Loader, { size: 1, gray: true, className: theme.loader }),
            React.createElement(pageMessage_1.PageMessage, { small: true, title: "Loading Cache Comparison", description: "Please wait..." })));
    };
    CacheComparison.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(pageMessage_1.PageMessage, { small: true, title: "Failed to load cache comparison", description: "We had an error loading the cache comparison.", iconName: "icon-rejected-status" })));
    };
    CacheComparison.prototype.renderCacheItem = function () {
        var _a = this.state.data, cacheItem = _a.cacheItem, isEqual = _a.isEqual, providerName = _a.providerName;
        var iconProps = {
            flat: true,
            outline: true,
            green: true,
            circle: true
        };
        if (!cacheItem) {
            return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.item },
                React.createElement(ui_1.Notification, { closeBtn: false, warning: true, title: "Not Exist In Cache!" })));
        }
        return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.codeScrollArea },
            React.createElement(ui_1.PopMessage, { className: theme.pre, green: isEqual, red: !isEqual },
                React.createElement(react_json_view_1.default, { src: cacheItem, displayDataTypes: false, sortKeys: true, theme: this._getJsonTheme(), style: { backgroundColor: "transparent" } }))));
    };
    CacheComparison.prototype._getJsonTheme = function () {
        var isDarkModeActive = document.documentElement.classList.contains("dark");
        if (isDarkModeActive) {
            return "bright";
        }
        else {
            return "rjv-default";
        }
    };
    CacheComparison.prototype.renderDifference = function () {
        var data = this.state.data;
        if (this.isWaiting()) {
            return null;
        }
        if (data.difference.length < 1) {
            return this.renderEmptyDifference();
        }
        return data.difference.map(function (item, idx) { return (React.createElement(nativeScrollable_1.NativeScrollable, { key: idx, className: theme.item },
            React.createElement(ui_1.Notification, { closeBtn: false, error: true, title: item.path ? item.path.join(", ") : "", text: "UI Settings: " + (item.rhs || "") + ", cache: " + (item.lhs || "") }))); });
    };
    CacheComparison.prototype.renderWarning = function () {
        var data = this.state.data;
        if (this.isWaiting()) {
            return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.item },
                React.createElement(ui_1.Notification, { closeBtn: false, title: "Cache is updating - Please wait" })));
        }
        if (!data.isEqual) {
            return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.item },
                React.createElement(ui_1.Notification, { closeBtn: false, warning: true, title: "Found difference between ui setting and Cache in - " + data.providerName })));
        }
    };
    CacheComparison.prototype.renderNotActive = function () {
        var isActiveItem = this.props.isActiveItem;
        if (!isActiveItem) {
            return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.item },
                React.createElement(ui_1.Notification, { closeBtn: false, warning: true, title: "This entity in not active!" })));
        }
    };
    CacheComparison.prototype.renderEmptyDifference = function () {
        return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.item },
            React.createElement(ui_1.Notification, { closeBtn: false, success: true, title: "No Found difference between ui setting and cache" })));
    };
    CacheComparison.prototype.renderData = function () {
        return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.list, height: "100%" },
            this.renderWarning(),
            this.renderNotActive(),
            this.renderDifference(),
            this.renderCacheItem()));
    };
    CacheComparison.prototype.render = function () {
        var _a = this.props, buttonText = _a.buttonText, buttonProps = _a.buttonProps, drawerProps = _a.drawerProps, spaceFromTop = _a.spaceFromTop, justIcon = _a.justIcon, isActiveItem = _a.isActiveItem;
        var _b = this.state, isOpen = _b.isOpen, isLoading = _b.isLoading, error = _b.error, data = _b.data;
        var panelStyle = {
            paddingTop: utils_2.toREMString(spaceFromTop)
        };
        var moreButtonProps = {
            green: true,
            iconName: "icon-approved-status"
        };
        if (!isActiveItem) {
            moreButtonProps = {
                gray: true,
                iconName: "icon-warning"
            };
        }
        else if (this.isWaiting()) {
            moreButtonProps = {
                gray: true,
                iconName: "icon-warning"
            };
        }
        else if (!_.isEmpty(data) && !data.isEqual) {
            moreButtonProps = {
                red: true,
                iconName: "icon-warning"
            };
        }
        return (React.createElement(React.Fragment, null,
            justIcon ? (React.createElement(ui_1.Tooltip, { title: buttonText },
                React.createElement(ui_1.IconButton, tslib_1.__assign({ flat: true }, buttonProps, moreButtonProps, { circle: true, onClick: this.onToggle })))) : (React.createElement(button_1.Button, tslib_1.__assign({}, buttonProps, moreButtonProps, { onClick: this.onToggle }), buttonText)),
            React.createElement(drawer_1.Drawer, tslib_1.__assign({}, drawerProps, { panelStyle: panelStyle, panelClass: theme.drawer, isOpen: isOpen, onClose: this.onToggle }),
                React.createElement(panelHeader_1.PanelHeader, { title: "Cache Comparison", onAction: this.onToggle, actionIconName: "icon-cancel-small" }),
                isLoading
                    ? this.renderLoader()
                    : (error || !data)
                        ? this.renderError()
                        : this.renderData())));
    };
    CacheComparison.defaultProps = {
        buttonText: "Cache Comparison",
        spaceFromTop: 6.8,
        isActiveItem: true,
        buttonProps: {
            outline: true,
            blue: true,
            iconName: "icon-copy"
        },
        drawerProps: {
            exitOnClickOutside: true,
            lockDocumentScroll: true,
            backdrop: true
        },
        isVidazooUser: false,
        justIcon: false
    };
    return CacheComparison;
}(containers_1.BaseContainer));
exports.default = CacheComparison;
